// extracted by mini-css-extract-plugin
export default {"container":"disciplines-list_container__RMb6M","root":"disciplines-list_root__bXirD"};